import {
  createStyles,
  Dialog,
  DialogActions,
  DialogContent,
  Divider,
  IconButton,
  makeStyles,
  Theme,
  Typography,
} from '@material-ui/core'
import { Close, Visibility } from '@material-ui/icons'
import { Edit } from '@mui/icons-material'
import React, { useState } from 'react'
import { useTranslate } from 'react-admin'
import { ResourceName } from '../../core/ResourceName'
import DraggableComponent from '../common/DraggableComponent'
import Button from '../common/customized-mui-components/Button'
import { DynamicPropertyDefinitionBaseDTO } from '../../core/dto/dynamic-property-definition.dto'
import { DynamicPropertyView } from './DynamicPropertyView'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    dialog: {
      minWidth: '300px',
    },
    actionsButton: {
      margin: '2%',
      width: '96%',
    },
    bulkStateActions: {
      height: '16px',
      background: 'rgba(0,0,0,0.2)',
      minWidth: '300px',
      userSelect: 'none',
    },
    bulkProgressTitle: {
      paddingLeft: '10px',
      width: '100%',
    },
    bulkProgressCloseButton: {
      margin: 0,
    },
    divider: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
    },
    showLayout: {
      display: 'flex',
      flexDirection: 'column',
    },
    editLayout: {
      padding: '0px !important',
    },
  }),
)

export const DynamicPropertyDialog = ({
  close,
  dynamicProperties,
  open,
  record,
  refetch,
  resource,
}: {
  close: () => void
  dynamicProperties?: DynamicPropertyDefinitionBaseDTO[]
  open: boolean
  record: any
  refetch: () => void
  resource: ResourceName
}) => {
  const classes = useStyles()
  const [editMode, setEditMode] = useState<boolean>(false)
  const translate = useTranslate()

  const handleEditMode = () => {
    setEditMode(!editMode)
  }

  const handleClose = () => {
    close()
    setEditMode(false)
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      disableBackdropClick
      disableEscapeKeyDown
      PaperComponent={DraggableComponent}
      aria-labelledby="draggable-dialog-title"
      className={classes.dialog}
      onClick={(e) => e.stopPropagation()}
    >
      <DialogActions
        className={classes.bulkStateActions}
        style={{ cursor: 'move' }}
      >
        <Typography
          className={classes.bulkProgressTitle}
          id="draggable-dialog-title"
        >
          {translate(`resources.${resource}.dialogs.dynamic-property.title`)}
        </Typography>
        <IconButton
          size="small"
          className={classes.bulkProgressCloseButton}
          onClick={handleClose}
        >
          <Close fontSize="small" />
        </IconButton>
      </DialogActions>
      <DialogContent
        className={!editMode ? classes.showLayout : classes.editLayout}
      >
        <DynamicPropertyView
          dynamicProperties={dynamicProperties}
          editMode={editMode}
          handleEditMode={handleEditMode}
          record={record}
          refetch={refetch}
          resource={resource}
        />
      </DialogContent>
      <Divider className={classes.divider} />
      <DialogActions>
        <Button
          variant="outlined"
          onClick={handleEditMode}
          label={!editMode ? 'ra.action.edit' : 'ra.action.show'}
          startIcon={!editMode ? <Edit /> : <Visibility />}
          useSmallVersionBreakpoint={false}
        />
      </DialogActions>
    </Dialog>
  )
}
